/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccountState } from '../models/AccountState';
import { CloudAccountType } from '../models/CloudAccountType';
import { Provider } from '../models/Provider';
import { RoleInstallationMethod } from '../models/RoleInstallationMethod';

export class Account {
  /**
  * The ID of the account
  */
  'id': string;
  'cloudProvider': Provider;
  /**
  * The account ID
  */
  'providerAccountId': string;
  /**
  * The role to access the account
  */
  'role': string;
  /**
  * The relevant regions for the account
  */
  'regions'?: Array<string>;
  'tags'?: { [key: string]: string; };
  /**
  * Friendly name for the account
  */
  'name': string;
  /**
  * The tenant ID (Used for Azure accounts)
  */
  'tenantId'?: string;
  /**
  * The application ID (Used for Azure restore accounts)
  */
  'applicationId'?: string;
  /**
  * The principal ID (Used for Azure restore accounts)
  */
  'principalId'?: string;
  /**
  * Whether this account overrides the default network configuration
  */
  'overrideDefaultNetworkConfig'?: boolean;
  /**
  * AWS organization ID.
  */
  'awsOrganizationId'?: string;
  'accountType'?: CloudAccountType;
  /**
  * Account is not visible for customer, and is intended for diagnostic eon purposes
  */
  'isInternal'?: boolean;
  'state'?: AccountState;
  /**
  * The version of the installed role on the account
  */
  'installedVersion'?: string;
  'installationMethod'?: RoleInstallationMethod;
  /**
  * The latest version of the role available for the account
  */
  'latestVersion'?: string;
  /**
  * Whether job metrics are enabled for the account
  */
  'isJobMetricsEnabled'?: boolean;
  /**
  * The target region for job metrics
  */
  'jobMetricsTargetRegion'?: string;
  /**
  * The user-defined name of the account within Eon
  */
  'eonCustomAccountName'?: string;
  /**
  * Display name inherited from the cloud provider.
  */
  'providerAccountName'?: string;
  /**
  * The internal Eon resource group name for Azure accounts, used for temporary resources
  */
  'eonInternalAzureResourceGroupName'?: string;
  /**
  * Date and time the account was connected to Eon.
  */
  'createdTime'?: Date;
  /**
  * The management group internal id for the account
  */
  'azureManagementGroup'?: string;
  /**
  * Optional. The resource group name that this account account is scoped to.
  */
  'azureResourceGroupName'?: string;
  /**
  * Whether this account is owned by the customer
  */
  'isCustomerOwned'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "providerAccountId",
      "baseName": "providerAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "role",
      "baseName": "role",
      "type": "string",
      "format": ""
    },
    {
      "name": "regions",
      "baseName": "regions",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": ""
    },
    {
      "name": "applicationId",
      "baseName": "applicationId",
      "type": "string",
      "format": ""
    },
    {
      "name": "principalId",
      "baseName": "principalId",
      "type": "string",
      "format": ""
    },
    {
      "name": "overrideDefaultNetworkConfig",
      "baseName": "overrideDefaultNetworkConfig",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "awsOrganizationId",
      "baseName": "awsOrganizationId",
      "type": "string",
      "format": ""
    },
    {
      "name": "accountType",
      "baseName": "accountType",
      "type": "CloudAccountType",
      "format": ""
    },
    {
      "name": "isInternal",
      "baseName": "isInternal",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "state",
      "baseName": "state",
      "type": "AccountState",
      "format": ""
    },
    {
      "name": "installedVersion",
      "baseName": "installedVersion",
      "type": "string",
      "format": ""
    },
    {
      "name": "installationMethod",
      "baseName": "installationMethod",
      "type": "RoleInstallationMethod",
      "format": ""
    },
    {
      "name": "latestVersion",
      "baseName": "latestVersion",
      "type": "string",
      "format": ""
    },
    {
      "name": "isJobMetricsEnabled",
      "baseName": "isJobMetricsEnabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "jobMetricsTargetRegion",
      "baseName": "jobMetricsTargetRegion",
      "type": "string",
      "format": ""
    },
    {
      "name": "eonCustomAccountName",
      "baseName": "eonCustomAccountName",
      "type": "string",
      "format": ""
    },
    {
      "name": "providerAccountName",
      "baseName": "providerAccountName",
      "type": "string",
      "format": ""
    },
    {
      "name": "eonInternalAzureResourceGroupName",
      "baseName": "eonInternalAzureResourceGroupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "createdTime",
      "baseName": "createdTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "azureManagementGroup",
      "baseName": "azureManagementGroup",
      "type": "string",
      "format": ""
    },
    {
      "name": "azureResourceGroupName",
      "baseName": "azureResourceGroupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "isCustomerOwned",
      "baseName": "isCustomerOwned",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return Account.attributeTypeMap;
  }

  public constructor() {
  }
}



